import { Page, DataTable } from "@shopify/polaris";
import usePaymentData from "../../../../hook/usePaymentData";
import { extractHour } from "../TotalSummary/TotalSummary";
import { LinkSummaryContainer } from "./LinkSummary.styles";

export function LinkSummary() {
  const { totalLink } = usePaymentData();

  const rows = (totalLink || []).map((payment) => [
    extractHour(payment.createdAt),
    `R$${(payment.amountCents / 100).toFixed(2)}`,
    payment.wasConciliation ? "Sim" : "Não",
    payment.orderName || "-",
  ]);

  let totalAmountCents = 0;

  for (const payment of totalLink || []) {
    const amountCents = parseInt(payment.amountCents, 10) || 0;
    totalAmountCents += amountCents;
  }

  const totalLinkFormatted = `R$${(totalAmountCents / 100).toFixed(2)}`;

  return (
    <LinkSummaryContainer>
      <Page title="Link de Pagamento">
        <DataTable
          showTotalsInFooter
          truncate
          fixedFirstColumns
          columnContentTypes={["text", "numeric", "numeric", "text"]}
          headings={["Hora", "Valor", "Avulso", "Pedido"]}
          rows={rows}
          totals={["", totalLinkFormatted, "", ""]}
          totalsName={{
            singular: "Total",
          }}
        />
      </Page>
    </LinkSummaryContainer>
  );
}
